export default "__VITE_ASSET__B9AWp9wr__"